import React from "react";

import "./SelectForm.css";

const FormField = ({
  label,
  name,
  value,
  handleChange,
  required = false,
  optionField
}) => {
  return (
    <div className="userUpdateItem">
      <label className="user__label">{label}</label>
      <select
       name={name}
       className="userUpdateInput"
       onChange={(e) => handleChange(e)}
       required={required}
       value={value}
       >

      {
        optionField?.map((e)=>{
          return (
            <option key={e} value={e}>{e}</option>
          )
        })
      }
      </select>
     
    </div>
  );
};

export default FormField;
